import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Tag, Space, Grid } from 'antd';
import { Router, useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeSelect,
	XThemeRadio,
	XEditButtonIcon,
} from '../../styles/GlobalThemeStyle';
import {
	PlusCircleFilled,
	PlusOutlined,
	UserOutlined,
} from '@ant-design/icons';
import moment from 'moment';
// Actions
import { getRolesApi, getRolesReset } from '../../actions/getRolesAction';
import {
	getRolesDropdownApi,
	getRolesDropdownReset,
} from '../../actions/getRolesDropdownAction';
import { getUsersApi, getUsersReset } from '../../actions/getUsersAction';
import { dateFilters } from '../../utils/constants';
// utils
import CaseSearch from '../../components/CaseSearch/CaseSearch';
import DataTable from '../../components/DataTable/DataTable';
import { checkModulePermissions, urlPagination } from '../../utils/helper';
import { XTheme2InnerCard } from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
} from '../../styles/GlobalThemeStyleCQ';

const UserManagement = (props) => {
	const {
		getUsers,
		getUsersReset,
		getUsersState,
		getRoles,
		getRolesState,
		getRolesDropdownState,
		getRolesDropdown,
	} = props;
	const navigate = useNavigate();
	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();

	const defaultFilters = {
		search: '',
		page: 1,
		patient_name: '',
		role: '',
		created_on: '',
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [open, setOpen] = useState(false);
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);
	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};
	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};
	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};
	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};
	const columns = [
		{
			title: 'User Name',
			dataIndex: 'userName',
		},
		{
			title: 'Role',
			dataIndex: 'role',
		},
		{
			title: 'Organization',
			dataIndex: 'organization',
		},
		{
			title: 'Region',
			dataIndex: 'region',
		},
		{
			title: 'Hospital',
			dataIndex: 'hospital',
		},
		{
			title: 'Active',
			dataIndex: 'is_active',
		},
		{
			title: 'Joined On',
			dataIndex: 'createdAt',
			sorter: (a, b) => a.createdAt - b.createdAt,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: <div className="text-center">Action</div>,
			dataIndex: 'action',
			width: '10%',
		},
	];

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('user-management').sub_modules.includes(
			'list-users',
		) && getUsers({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};
	const handleUserEdit = (item) => {
		navigate(`user/${item._id}`);
	};

	// use effects

	useEffect(() => {
		if (getUsersState.apiState === 'success') {
			if (getUsersState.data.all_users.length > 0) {
				setTotalRecords(getUsersState.data.total_count);
				const updatedUsers = [];
				getUsersState.data.all_users.map((item, index) => {
					updatedUsers.push({
						key: item._id,
						_id: item._id,
						userName: item.name,
						name: item.name,
						is_active: item.is_active ? (
							<Tag color="green">Active</Tag>
						) : (
							<Tag color="red">Suspended</Tag>
						),
						createdAt: moment(item.createdAt).format('DD-MM-YYYY'),
						role: item.role.display_name,
						organization: item.organization
							? item.organization
							: '-',
						region: item.region ? item.region : '-',
						hospital: item.hospital ? item.hospital : '-',
						action: (
							<div className="text-center">
								{checkModulePermissions(
									'user-management',
								).sub_modules.includes('update-users') ? (
									<XEditButtonIcon
										size="small"
										onClick={() => {
											handleUserEdit(item);
										}}
										type="text"
									>
										<img src="./images/pencil.svg" alt="" />
									</XEditButtonIcon>
								) : (
									<></>
								)}
							</div>
						),
					});
				});
				setTableData(updatedUsers);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
			getUsersReset();
		}
	}, [getUsersState]);

	// Functions
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<XTheme2InnerCard
				className="mb-3"
				bodyStyle={{ padding: '20px 0px' }}
			>
				<div className="smallTopBottomPadding mb-3 px-4">
					<CaseSearch
						searchOption="userManagement"
						title="Users"
						filters={[
							<XThemeForm.Item
								name="role"
								label="Roles"
								className="drawerlabel"
							>
								<XThemeSelect
									className="noBorderRadius"
									size="large"
									showSearch
									allowClear
									placeholder="Select Role"
									defaultValue={
										filters.role ? filters.role : null
									}
									onFocus={() =>
										getRolesDropdown({
											type: 'super-admin',
										})
									}
									onSelect={(value) => {
										setFilters({
											...filters,
											role: value,
										});
									}}
									onClear={() => {
										setFilters({
											...filters,
											role: '',
										});
									}}
									options={
										getRolesDropdownState.apiState ===
											'success' &&
										getRolesDropdownState.data.all_roles
											.length > 0 &&
										getRolesDropdownState.data.all_roles.map(
											(ele) => {
												return {
													key: ele._id,
													value: ele.role,
													label: ele.display_name,
												};
											},
										)
									}
								></XThemeSelect>
							</XThemeForm.Item>,
							<XThemeForm.Item
								name="created_on"
								colon={false}
								label="Date Within"
								className="drawerlabel"
							>
								<XThemeRadio.Group
									onChange={onChange}
									name="created_on"
									defaultValue={
										filters.created_on
											? filters.created_on
											: null
									}
								>
									<Row>
										{dateFilters.map((item, index) => (
											<Col
												xs={12}
												lg={12}
												md={12}
												xl={12}
											>
												<XThemeRadio value={item.value}>
													{item.label}
												</XThemeRadio>
											</Col>
										))}
									</Row>
								</XThemeRadio.Group>
							</XThemeForm.Item>,
						]}
						onClose={onClose}
						open={open}
						applyFilters={applyFilters}
						form={form2}
						clearFilters={clearFilters}
					/>
					<Row gutter={(15, 15)} className="align-items-center">
						<Col xs={16} sm={16} md={6} lg={4}>
							<h1
								className="cardTitle mb-0"
								style={{ fontSize: '18px' }}
							>
								Total {totalRecords} Users
							</h1>
						</Col>
						<Col
							xs={24}
							sm={16}
							md={12}
							lg={12}
							className="d-none d-md-block"
						>
							<Space>
								<XTheme2InputText
									size="large"
									allowClear
									placeholder="Search By User Name"
									defaultValue={
										filters.patient_name
											? filters.patient_name
											: null
									}
									onChange={(v) => {
										if (v.target.value === '') {
											urlPagination(
												filters,
												'patient_name',
												'',
											);
											setFilters({
												...filters,
												patient_name: '',
											});
										} else {
											setFilters({
												...filters,
												patient_name: v.target.value,
											});
										}
									}}
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											const searchValue =
												filters.patient_name
													? filters.patient_name
													: '';
											if (searchValue) {
												urlPagination(
													filters,
													'patient_name',
													searchValue,
												);
												setFilters({
													...filters,
													patient_name: searchValue,
												});
											}
										}
									}}
								/>
								<XTheme2Button
									onClick={() => {
										// Trigger search when the button is clicked
										const searchValue = filters.patient_name
											? filters.patient_name
											: '';
										if (searchValue) {
											urlPagination(
												filters,
												'patient_name',
												searchValue,
											);
											setFilters({
												...filters,
												patient_name: searchValue,
											});
										}
									}}
									className="px-4"
									size="large"
								>
									Search
								</XTheme2Button>
							</Space>
							{/* <XThemeForm.Item>
						<XSearch
							placeholder="Search By User Name"
							allowClear
							enterButton="Search"
							size="large"
							defaultValue={
								filters.patient_name
									? filters.patient_name
									: null
							}
							onChange={(v) => {
								if (v.target.value === '') {
									urlPagination(filters, 'patient_name', '');
									setFilters({
										...filters,
										patient_name: '',
									});
								}
							}}
							onSearch={(v) => {
								urlPagination(filters, 'patient_name', v);
								setFilters({
									...filters,
									patient_name: v,
								});
							}}
						/>
					</XThemeForm.Item> */}
						</Col>
						<Col xs={8} sm={8} md={6} lg={8} className="text-end">
							<Space>
								<XTheme2Button
									className="noBackground borderColor"
									shape="circle"
									size="large"
									onClick={() => showDrawer()}
									icon={
										<img
											src="/images/theme-filter-icon.svg"
											alt="filter"
										/>
									}
								/>
								{checkModulePermissions(
									'user-management',
								).sub_modules.includes('create-users') ? (
									isMobile ? (
										<XTheme2Button
											shape="circle"
											size="large"
											className="noBackground borderColor"
											onClick={() => {
												navigate(`user`);
											}}
											icon={<UserOutlined />}
										/>
									) : (
										<XTheme2Button
											size="large"
											onClick={() => {
												navigate(`user`);
											}}
											icon={<PlusOutlined />}
										>
											New User
										</XTheme2Button>
									)
								) : (
									<></>
								)}
							</Space>
						</Col>
					</Row>
				</div>

				<DataTable
					columns={columns}
					tableData={tableData}
					setFilters={setFilters}
					filters={filters}
					totalRecords={totalRecords}
					state={getUsersState.apiState}
					page={'user-management'}
					handleEdit={handleUserEdit}
				/>
			</XTheme2InnerCard>
		</>
	);
};

const mapStateToProps = (state) => ({
	getUsersState: state.getUsers,
	getRolesState: state.getRoles,
	getRolesDropdownState: state.getRolesDropdown,
});

const mapDispatchToProps = (dispatch) => ({
	getUsers: (params) => dispatch(getUsersApi(params)),
	getUsersReset: () => dispatch(getUsersReset()),
	getRoles: (params) => dispatch(getRolesApi(params)),
	getRolesDropdown: (params) => dispatch(getRolesDropdownApi(params)),
	getRolesReset: () => dispatch(getRolesReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
